import { render } from "./Post_top.vue?vue&type=template&id=d46832ca&scoped=true&ts=true"
import script from "./Post_top.vue?vue&type=script&lang=ts"
export * from "./Post_top.vue?vue&type=script&lang=ts"

import "./Post_top.vue?vue&type=style&index=0&id=d46832ca&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d46832ca"]])

export default __exports__